import Attachment from "../../../components/drag_and_drop/Attachment/Attachment.vue";
import { loadingOverlay } from "vuetify-more-component";
import * as XLSX from 'xlsx';

export default {
  components: {
    Attachment,
    loadingOverlay
  },
  data() {
    return {
      items: [
        { tab: 'Notificaciones', content: 'man_not' },
        { tab: "TicLabsCa", content: 'man_solicitud_facturacion' },
        { tab: 'Servicios Extras', content: 'man_servicios' },
        { tab: 'Cupones', content: 'man_cupon' },
        { tab: "Configuración de meses de suscripción", content: 'man_conf_mes' },
        { tab: "Día declaración sin retenciones", content: 'man_conf_decla' },
        { tab: 'Agentes retenedores de IVA', content: 'con_ret' },
      ],
      tab: null,
      info: {
        asunto: "",
        mensaje: "",
        documento: null,
        regimen_id: null,
        usuario_id: null,
        enviar_whatsapp: false,
        categoria_whatsapp: null
      },
      panel_cargas: [0],
      loading_retenedores: false,
      listado_retenedores: [],
      listado_retenedores_iva: [],
      files: [],
      loading: false,
      tipoRegimen: [],
      usuarios: [],
      documento: null,
      buscar_usuarios: '',
      loading_confirmar_correo: false,
      dialogConfirmarCorreo: false,
      columnas_retenedores_iva: [
        { text: 'NIT', value: 'nit', class: "success--dark title", align: 'center' },
        { text: 'Nombre retenedor', value: 'nombre', class: "success--dark title", align: 'center' },
        { text: 'Acciones', value: 'acciones', editable: false, align: 'center' }
      ],
      columnas_retenedores_preview: [
        { text: 'NIT', value: 'nit', class: "success--dark title", align: 'center' },
        { text: 'Nombre retenedor', value: 'nombre', class: "success--dark title", align: 'center' },
        { text: 'fecha', value: 'fecha', class: "success--dark title", align: 'center' },
      ],
      buscar_retenedores: '',
      dialog_cargar_retenedores_iva: false,
      dialog_cargar_retenedores_isr: false,
      columnasRegimenes: [
        {
          text: 'Descripción',
          align: 'start',
          sortable: true,
          value: 'descripcion',
        },
        {
          text: 'Límite notificación',
          align: 'start',
          sortable: true,
          value: 'limite_notificacion',
        },
        {
          text: 'Modificar',
          align: 'start',
          sortable: false,
          value: 'acciones',
        },
      ],
      filasRegimenes: [],
      loading_regimenes: false,
      buscar_regimen: '',
      regimen: {
        id: 0,
        limite_notificacion: 0,
        descripcion: ''
      },
      default_regimen: {
        id: 0,
        limite_notificacion: 0,
        descripcion: ''
      },
      dialogRegimen: false,
      item_aux_regimen: null,
      conf_precio: {
        value: "1234567.89",
        label: "Precio de la suscripción",
        readonly: false,
        disabled: false,
        outlined: false,
        clearable: false,
        options: {
          locale: "en-US",
          prefix: "Q. ",
          suffix: "",
          length: 9,
          precision: 2
        },
      },
      loading_boton_suscripcion: false,
      columnas_meses_conf: [
        { text: "Mes", value: "mes", sortable: true },
        { text: "Fecha inicio", value: "fecha_inicio", sortable: true },
        { text: "Fecha fin", value: "fecha_fin", sortable: true },
        { text: "Acciones", value: "actions", sortable: true }
      ],
      items_meses_conf: [],
      item_meses:
      {
        id: -1,
        mes: null,
        fecha_inicio: null,
        fecha_fin: null,
      },
      default_meses:
      {
        id: -1,
        mes: null,
        fecha_inicio: null,
        fecha_fin: null,
      },
      crear_meses: false,
      dialog_meses_config: false,
      loading_meses: false,
      items_meses: [
        { mes: 1, text: "Enero" },
        { mes: 2, text: "Febrero" },
        { mes: 3, text: "Marzo" },
        { mes: 4, text: "Abril" },
        { mes: 5, text: "Mayo" },
        { mes: 6, text: "Junio" },
        { mes: 7, text: "Julio" },
        { mes: 8, text: "Agosto" },
        { mes: 9, text: "Septiembre" },
        { mes: 10, text: "Octubre" },
        { mes: 11, text: "Noviembre" },
        { mes: 12, text: "Diciembre" },
      ],
      menu_picker1: false,
      mene_picker2: false,
      txt_fecha_inicio: '',
      txt_fecha_fin: '',
      columnas_declaracion: [
        { text: 'Día declaración', value: 'dia' },
        { text: 'Acciones', value: 'acciones' },
      ],
      filas_declaracion: [],
      item_aux: { id: null, dia: null },
      dialog_dia_declaracion_retenciones: false,
      loading_btn_retenciones: false,
      items_dias: [],
      retenciones_cargadas: [],
      retenciones_cargadas_iva: [],
      columnas_retenciones_cargadas: [
        { text: 'Estado', value: 'activo' },
        { text: 'Fecha de carga', value: 'fecha_carga' },
        { text: 'Fecha de vencimiento', value: 'fecha_vencimiento' },
        { text: 'Detalle', value: 'detalle' }
      ],
      loading_retenciones: false,
      dialog_consulta_listado_retenedores: false,
      item_aux_retencion: null,
      item_retenedor_Edit: {
        id: null,
        nombre: null,
        nit: null,
        editar: false
      },
      isIva: false,
      dialog_limite_retenciones: false,
      isLimiteIva: false,
      item_aux_dia_limite: {
        id: null,
        dia: null,
        mes: null,
        anio: null,
        fecha: null,
      },
      items_anios: [],
      items_dia_limite: [],
      columnas_dia_limite: [
        { text: 'Día', value: 'dia' },
        { text: 'Mes', value: 'mes' },
        { text: 'Año', value: 'anio' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Acciones', value: 'acciones' },
      ],
      loading_dia_limite: false,
      loading_insertar_dia_limite: false,
      isCreate: true,
      cargaTabla: false,

      columnas_cupones: [
        { text: 'Código', value: 'codigo' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Valor', value: 'valor' },
        { text: 'Activo', value: 'activo' },
        { text: 'Grupo', value: 'rol_id' },
        { text: 'Acciones', value: 'acciones' }
      ],
      filasCupones: [],
      loading_cupones: false,
      dialog_cupones: false,
      buscar_cupones: '',
      item_aux_cupon: {
        id: null,
        codigo: null,
        tipo: null,
        valor: null,
        rol_id: null,
        activo: null
      },
      default_cupon: {
        id: null,
        codigo: null,
        tipo: null,
        valor: null,
        rol_id: null,
        activo: null
      },
      user_types: [],
      loading_user_types: false,

      buscar_servicio: '',
      filasServiciosExtras: [],
      loading_servicios: false,
      columnasServiciosExtras: [
        { text: 'Titulo', value: 'titulo' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Precio', value: 'precio' },
        { text: 'Activo', value: 'activo' },
        { text: 'Acciones', value: 'acciones' }
      ],

      dialog_servicios_extras: false,

      item_aux_servicio: {
        id: null,
        nombre: null,
        descripcion: null,
        precio: null,
        activo: null
      },
      default_servicio: {
        id: null,
        nombre: null,
        descripcion: null,
        precio: null,
        activo: null
      },

      cat_whatsapp: [
        "dt_servicio_rango_facturas",
        "dt_tarjeta",
        "dt_recordatorio",
        "dt_declaracion",
      ],

      isLoginTicLabsCa: false,
      isRequestFacturas: false,
      isMoveFacturas: false,

      items_meses: [
        { text: 'Enero', value: '01' },
        { text: 'Febrero', value: '02' },
        { text: 'Marzo', value: '03' },
        { text: 'Abril', value: '04' },
        { text: 'Mayo', value: '05' },
        { text: 'Junio', value: '06' },
        { text: 'Julio', value: '07' },
        { text: 'Agosto', value: '08' },
        { text: 'Septiembre', value: '09' },
        { text: 'Octubre', value: '10' },
        { text: 'Noviembre', value: '11' },
        { text: 'Diciembre', value: '12' },
      ],
      anios: [],
      mes_inicio: null,
      anio_seleccionado: null,
      mes_fin: null,
      anio_fin_seleccionado: null,
      usuario_seleccionado: null,

    };
  },
  async created() {
    console.log("/man_gen.0");
    this.getDias();
    this.getAnios();

    // busca en el session storage si viene de tic labs ca
    if (sessionStorage.getItem("api_ticlabs_login") === "true") {
      this.isLoginTicLabsCa = true;
    }

    if (sessionStorage.getItem("api_ticlabs_sol") === "true") {
      this.isRequestFacturas = true;
    }

    let anio_actual = new Date().getFullYear();
    for (let index = anio_actual - 10; index <= anio_actual; index++) {
      this.anios.push(index);
    }
  },
  watch: {
    async documento(value) {
      console.log("documento", value);
      if (value === null || this.documento === null) {
        console.log("si");
        this.info.documento = null;
        return;
      }
      try {
        let fr = new FileReader()
        fr.addEventListener("load", async (e) => {
          //this is your base64
          this.info.documento = e.target.result;
          // console.log(e.target.result)
          this.loading = false;
        });
        fr.readAsDataURL(value)
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
      console.log("value", value)
    },
    "item_meses.fecha_inicio"() {
      console.log('item_meses.fecha_inicio', this.item_meses);
      if (this.item_meses.fecha_inicio != null) {
        this.txt_fecha_inicio = this.item_meses.fecha_inicio.split("-").reverse().join("/");
      } else {
        this.txt_fecha_inicio = "";
      }
    },
    "item_meses.fecha_fin"() {
      console.log('item_meses.fecha_fin');
      if (this.item_meses.fecha_fin != null) {
        this.txt_fecha_fin = this.item_meses.fecha_fin.split("-").reverse().join("/");
      } else {
        this.txt_fecha_fin = "";
      }
    },
    dialog_meses_config(val) {
      console.log("dialog_meses_config", val);
      val || this.cerrar_modal_meses();
    },
    dialog_cargar_retenedores_iva(val) {
      console.log("llega", val);
      val || this.cerrar_modal_retenedores();
    },
    dialog_cargar_retenedores_isr(val) {
      console.log("dialog_cargar_retenedores_isr", val);
      val || this.cerrar_modal_retenedores();
    },
    async dialog_limite_retenciones(val) {
      console.log("dialog_limite_retenciones", val);
      if (val) {
        // busca el item en el listado
        await this.getFechaLimite();
      } else {
        // si es false, se cierra el modal
        this.isCreate = true;
        this.item_aux_dia_limite = Object.assign({}, this.item_aux_dia_limite);
      }
    },
    dialog_consulta_listado_retenedores(val) {
      console.log("dialog_consulta_listado_retenedores", val);
      val || this.cerrar_modal_retenedores();
    },

    dialog_cupones(val) {
      val || this.cerrar_modal_cupones();
    },

    dialog_servicios_extras(val) {
      val || this.cerrar_modal_servicios_extras();
    },

  },
  computed: {
  },
  methods: {

    async listadoServiciosExtras() {
      console.log("listadoServiciosExtras");
      try {
        this.loading_servicios = true;
        let r = await this.$store.state.services.usuarioService.listadoServiciosExtras();
        console.log(r, "listado de servicios extras");
        this.filasServiciosExtras = r.data.data;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el listado de servicios extras");
      } finally {
        this.loading_servicios = false;
      }
    },

    modificarServicio(item) {
      console.log("modificarServicio", item);
      this.item_aux_servicio = Object.assign({}, item);
      this.dialog_servicios_extras = true;
      this.isCreate = false;
    },

    cerrar_modal_servicios_extras() {
      this.dialog_servicios_extras = false;
      this.item_aux_servicio = Object.assign({}, this.default_servicio);
      this.isCreate = true;
    },

    async crearServicio() {
      console.log("crearServicio");
      this.item_aux_servicio = Object.assign({}, this.default_servicio);
      this.dialog_servicios_extras = true;
      this.isCreate = true;
    },

    async confirmarModificarServicio() {
      try {
        console.log("confirmarModificarServicio", this.item_aux_servicio);
        this.loading_servicios = true;
        let r = await this.$store.state.services.usuarioService.actualizarServicioExtra(this.item_aux_servicio);
        console.log("confirmarModificarServicio", r);
        this.listadoServiciosExtras();
        this.cerrar_modal_servicios_extras();
        this.$toast.success("Servicio extra actualizado exitosamente");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_servicios = false;
      }
    },

    async confirmarCrearServicio() {
      try {
        console.log("confirmarCrearServicio", this.item_aux_servicio);
        this.loading_servicios = true;
        let r = await this.$store.state.services.usuarioService.insertarServicioExtra(this.item_aux_servicio);
        console.log("confirmarCrearServicio", r);
        this.listadoServiciosExtras();
        this.cerrar_modal_servicios_extras();
        this.$toast.success("Servicio extra creado exitosamente");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible crear el servicio extra");
      } finally {
        this.loading_servicios = false;
      }
    },

    async listUserTypes() {
      try {
        this.loading_user_types = true;
        let r = await this.$store.state.services.gestoresService.listUserTypes();
        this.user_types = r.data.data;
        this.loading_user_types = false;
      } catch {
        this.$toastr.error("Ocurrió un error al obtener los tipos de usuario");
        this.loading_user_types = false;
      }
    },

    cierraTodosRetenedorIVA() {
      this.listado_retenedores.forEach(x => {
        if (x.editar) {
          x.editar = false;
        }
      });
    },

    crearRetenedorIVA() {
      this.cierraTodosRetenedorIVA();
      console.log("crearRetenedorIVA");
      this.item_retenedor_Edit = Object.assign({}, this.item_retenedor_Edit);
      this.listado_retenedores.push({
        id: -1,
        nombre: null,
        nit: null,
        editar: true
      });
      this.item_retenedor_Edit = {
        id: -1,
        nombre: null,
        nit: null,
        editar: true
      }
      // hay alguna manera de forzar para que aparezca al inicio del listado
      this.listado_retenedores = [this.listado_retenedores.pop(), ...this.listado_retenedores];
    },

    async confimar_modificarRetenedorIVA() {
      console.log("confimar_modificarRetenedorIVA", this.item_aux_retencion);
      let index = this.listado_retenedores.findIndex(x => x.id === this.item_retenedor_Edit.id);
      this.listado_retenedores[index].nombre = this.item_retenedor_Edit.nombre;
      this.listado_retenedores[index].nit = this.item_retenedor_Edit.nit;
      this.listado_retenedores[index].editar = false;
      this.listado_retenedores = Object.assign([], this.listado_retenedores);
      try {
        let r = null;
        this.loading_retenedores = true;
        if (this.item_retenedor_Edit.id === -1) {
          if (this.isIva) {
            r = await this.$store.state.services.administradorService.postInsertarRetenedorIndividualIVA(
              {
                nombre: this.item_retenedor_Edit.nombre,
                nit: this.item_retenedor_Edit.nit
              }
            )
            this.verDetalleCargaRetenedoresIVA(this.item_aux_retencion);
          } else {
            r = await this.$store.state.services.administradorService.postInsertarRetenedorIndividual(
              {
                nombre: this.item_retenedor_Edit.nombre,
                nit: this.item_retenedor_Edit.nit
              }
            );
            this.verDetalleCargaRetenedores(this.item_aux_retencion);
          }
          console.log(r);
          this.$toast.success("Retenedor creado exitosamente");
        } else {
          if (this.isIva) {
            r = await this.$store.state.services.administradorService.actualizarRetenedorIndividualIVA(
              {
                id: this.item_retenedor_Edit.id,
                nombre: this.item_retenedor_Edit.nombre,
                nit: this.item_retenedor_Edit.nit
              }
            )
            this.verDetalleCargaRetenedoresIVA(this.item_aux_retencion);
          } else {
            r = await this.$store.state.services.administradorService.actualizarRetenedorIndividual(
              {
                id: this.item_retenedor_Edit.id,
                nombre: this.item_retenedor_Edit.nombre,
                nit: this.item_retenedor_Edit.nit
              }
            );
            this.verDetalleCargaRetenedores(this.item_aux_retencion);
          }
          console.log(r);
          this.$toast.success("Retenedor actualizado exitosamente");
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible actualizar el retenedor");
      } finally {
        this.loading_retenedores = false;
      }
      this.item_retenedor_Edit = Object.assign({}, item);
    },

    modificarRetenedorIVA(item) {
      this.cierraTodosRetenedorIVA();
      console.log('modificarRetenedorIVA', item);
      let index = this.listado_retenedores.findIndex(x => x.id === item.id);
      this.listado_retenedores[index].editar = true;
      this.listado_retenedores = Object.assign([], this.listado_retenedores);
      this.item_retenedor_Edit = Object.assign({}, item);
    },

    async eliminarRetenedorIVA(item) {
      console.log('eliminarRetenedorIVA', item);
      // retira el item del listado
      let index = this.listado_retenedores.findIndex(x => x.id === item.id);
      this.listado_retenedores.splice(index, 1);
      this.listado_retenedores = Object.assign([], this.listado_retenedores);
      // elimina el item de la base de datos
      this.loading_retenedores = true;
      try {
        if (this.isIva) {
          await this.$store.state.services.administradorService.eliminarRetenedorIndividualIVA({ id: item.id });
        } 
        this.$toast.success("Retenedor eliminado exitosamente");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible eliminar el retenedor");
      } finally {
        this.loading_retenedores = false;
      }
    },

    cancelarEdicion(item) {
      console.log('cancelarEdicion');
      let index = this.listado_retenedores.findIndex(x => x.id === item.id);
      this.listado_retenedores[index].editar = false;
      this.listado_retenedores = Object.assign([], this.listado_retenedores);
      this.item_retenedor_Edit = {
        id: null,
        nombre: null,
        nit: null,
        editar: false
      };
      // limpia el array si el id es -1
      if (item.id === -1) {
        this.listado_retenedores.splice(index, 1);
        this.listado_retenedores = Object.assign([], this.listado_retenedores);
      }
    },

    async verDetalleCargaRetenedores(item) {
      console.log("verDetalleCargaRetenedores", item);
      try {
        item.loading = true;
        let r = await this.$store.state.services.administradorService.DetalleCargaRetenedores(item.id);
        this.listado_retenedores = r.data.data;
        // por cada uno agrega la variable editar
        this.item_aux_retencion = item;
        console.log(this.item_aux_retencion);
        this.listado_retenedores.forEach(x => x.editar = false);
        this.dialog_consulta_listado_retenedores = true;
        console.log("detalle carga de retenedores", r);
        this.isIva = false;
        item.loading = false;
      } catch (error) {
        item.loading = false;
        console.log(error);
        this.$toast.error("No es posibe consultar el detalle de la carga de retenedores")
      }
    },

    async verDetalleCargaRetenedoresIVA(item) {
      console.log("verDetalleCargaRetenedoresIVA", item);
      try {
        console.log("llega el item", item);
        item.loading = true;
        let r = await this.$store.state.services.administradorService.detalleListadoCargaRetenedoresIVA(item.id);
        this.listado_retenedores = r.data.data;
        // por cada uno agrega la variable editar
        this.item_aux_retencion = item;
        console.log(this.item_aux_retencion);
        this.listado_retenedores.forEach(x => x.editar = false);
        this.dialog_consulta_listado_retenedores = true;
        console.log("detalle carga de retenedores", r);
        item.loading = false;
        this.isIva = true;
      } catch (error) {
        item.loading = false;
        console.log(error);
        this.$toast.error("No es posibe consultar el detalle de la carga de retenedores")
      }
    },

    cerrar_modal_retenedores() {
      console.log("cerrar_modal_retenedores");
      this.listado_retenedores = [];
      this.dialog_cargar_retenedores_iva = false;
      this.loading_retenedores = false;
    },

    async almacenarRetenedores(retenedores) {
      console.log("almacenarRetenedores", retenedores);
      try {
        this.loading_retenedores = true;
        let r = await this.$store.state.services.administradorService.postInsertaRetenedores({ retenedores: retenedores })
        console.log(r);
        this.listado_retenedores = retenedores;
        this.loading_retenedores = false;
        this.$toast.success("Retenedores cargados exitosamente, se muestra el listado de los mismos",
          { timeout: 5000, position: "top-center" });
        this.listadoCargasRetenedores();
      } catch (error) {
        console.log(error, 'error almacenar retenedores !');
        this.loading_retenedores = false;
      }
    },

    async almacenarRetenedoresIVA(retenedores) {
      console.log("almacenarRetenedoresIVA", retenedores);
      console.log(retenedores);
      try {
        this.loading_retenedores = true;
        let r = await this.$store.state.services.administradorService.postInsertaRetenedoresIVA({ retenedores: retenedores })
        console.log(r);
        console.log(r.data.success);
        

        if(r.data.success === false){
          this.$toast.error("No se pudo cargar los retenedores IVA, comuníquese con soporte", { timeout: 7000, position: "top-center" });
          this.loading_retenedores = false;
          return;
        }
        this.listado_retenedores = retenedores;
        this.loading_retenedores = false;
        this.$toast.success("Retenedores IVA cargados exitosamente, se muestra el listado de los mismos",
          { timeout: 5000, position: "top-center" });
        this.listadoCargaRetenedoresIVA();
      } catch (error) {
        console.log(error, 'error almacenar retenedores !');
        this.loading_retenedores = false;
      }
    },

    getDias() {
      console.log("getDias");
      for (let index = 1; index <= 31; index++) {
        this.items_dias.push(index);
      }
    },

    getAnios() {
      console.log("getAnios");
      let anio_actual = new Date().getFullYear();
      for (let index = anio_actual; index <= anio_actual + 10; index++) {
        this.items_anios.push(index);
      }
    },

    editar_columnas_declaracion(item) {
      console.log('editar_columnas_declaracion', item);
      this.item_aux = Object.assign(this.item_aux, item);
      console.log('item aux', this.item_aux);
      this.dialog_dia_declaracion_retenciones = true;
    },

    async dia_movimiento_listado() {
      console.log('dia_movimiento_listado');
      try {
        this.loading_btn_retenciones = true;
        let r = await this.$store.state.services.administradorService.dia_movimiento_listado();
        console.log(r, "dia movimiento listado");
        this.loading_btn_retenciones = false;
        this.filas_declaracion = r.data.data;
      } catch (error) {
        console.log(error);
        this.loading_btn_retenciones = false;
        this.$toast.error('No es posible obtener el listado para gestionar el mantenimiento de fechas de declaraciones')
      }
    },
    async dia_movimiento_actualizar() {
      console.log('dia_movimiento_actualizar');
      try {
        this.loading_btn_retenciones = true;
        let r = await this.$store.state.services.administradorService.dia_movimiento_actualizar(this.item_aux);
        console.log(r, 'actualizacion movimiento dia');
        this.$toast.success("Día de presentación sin retenciones ha sido modificado exitosamente");
        this.loading_btn_retenciones = false;
        this.dialog_dia_declaracion_retenciones = false;
        this.dia_movimiento_listado();
        // this.item_aux  = Object.assign({}, item_aux);
      } catch (error) {
        this.loading_btn_retenciones = false;
        console.log(error);
        this.$toast.error("No es posible actualizar la fecha para el boton de presentar sin declaraciones")
      }
    },
    async listado_fecha_declaracion() {
      console.log("listado_fecha_declaracion");
      try {
        this.loading_meses = true;
        let r = await this.$store.state.services.administradorService.listado_fecha_declaracion();
        console.log(r, "información obtenida de listado declaración");
        this.items_meses_conf = r.data.data;
        this.loading_meses = false;
      } catch (error) {
        console.log(error);
        this.loading_meses = false;
        this.$toast.error("No es posible obtener la información de los meses")
      }
    },
    nombre_mes(numero) {
      console.log("nombre_mes", numero);
      switch (numero) {
        case 1:
          return "Enero";
        case 2:
          return "Febrero";
        case 3:
          return "Marzo";
        case 4:
          return "Abril";
        case 5:
          return "Mayo";
        case 6:
          return "Junio";
        case 7:
          return "Julio";
        case 8:
          return "Agosto";
        case 9:
          return "Septiembre";
        case 10:
          return "Octubre";
        case 11:
          return "Noviembre";
        case 12:
          return "Diciembre";
        default:
          break;
      }
    },
    edit_mes(item) {
      console.log("edit_mes", item);
      console.log("item seleccionado");
      this.item_meses = Object.assign({}, item)
      this.crear_meses = false;
      this.dialog_meses_config = true;
    },
    crear_mes() {
      console.log("crear_mes");
      this.crear_meses = true;
      this.dialog_meses_config = true;
    },
    async crear_editar_mes() {
      console.log("crear_editar_mes");
      this.crear_meses ? this.confirmar_crear_mes() : this.confirmar_editar_mes();
    },
    async confirmar_crear_mes() {
      console.log("confirmar_crear_mes");
      try {
        this.loading_meses = true;
        let r = await this.$store.state.services.administradorService.insertar_fecha_declaracion(this.item_meses);
        console.log(r, "información obtenida de insert declaración");
        this.$toast.success("Mes creado exitosamente");
        this.dialog_meses_config = false;
        this.loading_meses = false;
        await this.listado_fecha_declaracion();
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible crear el mes")
        this.loading_meses = false;
      }
    },
    async confirmar_editar_mes() {
      console.log("confirmar_editar_mes");
      try {
        this.loading_meses = true;
        let r = await this.$store.state.services.administradorService.modificar_fecha_declaracion(this.item_meses);
        console.log(r, "información obtenida de insert declaración");
        this.$toast.success("Mes modificado exitosamente");
        this.dialog_meses_config = false;
        this.loading_meses = false;
        await this.listado_fecha_declaracion();
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible editar el mes")
        this.loading_meses = false;
      }
    },
    cerrar_modal_meses() {
      console.log("cerrar_modal_meses");
      this.item_meses = Object.assign({}, this.default_meses);
      this.crear_meses = false;
    },
    convertirnumero(numero) {
      console.log("convertirnumero:", numero);
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },
    modificarRegimen(item) {
      console.log("modificarRegimen", item);
      this.item_aux_regimen = item;
      console.log(this.item_aux_regimen);
      this.dialogRegimen = true;
      this.regimen.id = item.id;
      this.regimen.descripcion = item.descripcion;
      this.regimen.limite_notificacion = item.limite_notificacion;
    },
    async confirmarModificarRegimen() {
      console.log("confirmarModificarRegimen");
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.administradorService.putActualizarRegimen(this.regimen);
        console.log(r);
        this.$toast.success("Régimen Actualizado con éxito");
        this.loading_boton_suscripcion = false;
        this.limpiar_regimen();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible crear el régimen")
      }
    },
    async confirmarCrearRegimen() {
      console.log("confirmarCrearRegimen");
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.administradorService.postInsertarRegimen(this.regimen);
        console.log(r);
        this.$toast.success("Régimen Creado con éxito");
        this.loading_boton_suscripcion = false;
        this.limpiar_regimen();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible crear el régimen")
      }
    },
    limpiar_regimen() {
      console.log("limpiar_regimen");
      this.dialogRegimen = false;
      this.item_aux_regimen = null;
      this.regimen = this.default_regimen;
      this.getRegimenListadoAux();
    },
    crearRegimen() {
      console.log("crearRegimen");
      this.item_aux_regimen = null;
      this.dialogRegimen = true;
      this.regimen.id = 0;
      this.regimen.descripcion = '';
      this.regimen.limite_notificacion = 0;
    },
    async seleccionTab(tipo) {
      console.log('seleccionTab:', tipo);
      this.cargaTabla = true;
      if (tipo == 'man_servicios') {
        await this.listadoServiciosExtras();
      } else if (tipo == 'man_conf_mes') {
        await this.listado_fecha_declaracion();
      } else if (tipo == 'man_conf_decla') {
        await this.dia_movimiento_listado();
      } else if (tipo == 'con_ret') {
        await this.listadoCargaRetenedoresIVA();
      } else if (tipo == 'man_cupon') {
        await this.getCupones();
        await this.listUserTypes();
      } else if (tipo == 'man_not') {
        await this.getUsuarios();
        await this.getRegimenListado();
      }
    },
    async listadoCargasRetenedores() {
      console.log("listadoCargasRetenedores");
      try {
        this.loading_retenciones = true;
        let r = await this.$store.state.services.administradorService.listadoCargasRetenedores();
        console.log('listadoCargasRetenedores:', r);
        r.data.data.filter(x => x.loading = false);
        this.retenciones_cargadas = r.data.data;
        this.loading_retenciones = false;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible listar los retenerdores")
        this.loading_retenciones = false;
      }
    },
    async listadoCargaRetenedoresIVA() {
      console.log("listadoCargaRetenedoresIVA");
      try {
        this.loading_retenciones = true;
        let r = await this.$store.state.services.administradorService.listadoCargaRetenedoresIVA();
        console.log('retenedores cargados IVA', r);
        r.data.data.filter(x => x.loading = false);
        this.retenciones_cargadas_iva = r.data.data;
        this.loading_retenciones = false;
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible listar los retenerdores")
        this.loading_retenciones = false;
      }
    },
    async getRegimenListadoAux() {
      console.log("getRegimenListadoAux");
      try {
        this.loading_regimenes = true;
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        console.log(r);
        this.filasRegimenes = r.data.data
        this.loading_regimenes = false;
      } catch (error) {
        this.loading_regimenes = false;
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },
    async correo_masivo() {
      console.log("correo_masivo");
      try {
        this.loading_confirmar_correo = true;
        let r = await this.$store.state.services.administradorService.correo_masivo(this.info);
        console.log(r);
        if (r.data.success === false) {
          this.$toast.error("Error al enviar correo", { timeout: 5000, position: "top-center" });
        } else {
          this.$toast.success("Usuario(s) notificados exitosamente", { timeout: 5000, position: "top-center" });
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible enviar esta notificación a los usuarios")
      } finally {
        this.dialogConfirmarCorreo = false;
        this.loading_confirmar_correo = false;

        // limpiar info
        this.info = {
          asunto: null,
          mensaje: null,
          documento: null,
          usuario_id: null,
          regimen_id: null
        };
        this.documento = null;
      }
    },
    async getUsuarios() {
      console.log("getUsuarios");
      this.loading = true;
      try {
        let r =
          await this.$store.state.services.administradorService.getUsuarios();
        console.log(r);
        r.data.data.filter((x) => {
          x.nombre =
            (x.primer_nombre === null ? '' : x.primer_nombre) +
            " " +
            (x.segundo_nombre === null ? '' : x.segundo_nombre) +
            " " +
            (x.primer_apellido === null ? '' : x.primer_apellido) +
            " " +
            (x.segundo_apellido === null ? '' : x.segundo_apellido);
        });
        this.usuarios = r.data.data;
        this.usuarios.push({ id: null, nombre: "A TODOS" })
        this.usuarios.reverse();
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los usuarios"
        );
        this.loading = false;
      }
    },
    async getRegimenListado() {
      console.log("getRegimenListado");
      try {
        this.loading = true;
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        console.log("tipo regimen", r);
        this.tipoRegimen = r.data.data;
        this.tipoRegimen.push({ id: null, descripcion: "A TODOS" })
        this.tipoRegimen.reverse();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },
    enviarCorreo() {
      console.log("enviarCorreo");
      console.log(this.info);
      console.log(this.$refs.formEnviarCorreoMasivo);
      if (this.$refs.formEnviarCorreoMasivo[0].validate()) {
        this.dialogConfirmarCorreo = true;
      }
    },
    async getFechaLimite() {
      console.log("getFechaLimite");
      try {
        this.loading_dia_limite = true;
        let r = null;
        if (this.isLimiteIva) {
          r = await this.$store.state.services.administradorService.getFechaLimiteIVA();
        } else {
          r = await this.$store.state.services.administradorService.getFechaLimiteISR();
        }
        console.log("Fecha limite iva", r);
        this.items_dia_limite = r.data.data;
        this.loading_dia_limite = false;
      } catch (error) {
        this.loading_dia_limite = false;
        console.log(error);
        this.$toast.error("No es posible obtener la fecha limite de retenciones IVA")
      }
    },
    async insertarFechaLimites() {
      console.log("insertarFechaLimites");
      try {
        let r = null;
        this.loading_insertar_dia_limite = true;
        let dia = this.item_aux_dia_limite.dia;
        let mes = this.item_aux_dia_limite.mes;
        let anio = this.item_aux_dia_limite.anio;
        let fecha = `${anio}-${mes}-${dia}`;
        this.item_aux_dia_limite.fecha = fecha;
        if (this.isLimiteIva) {
          r = await this.$store.state.services.administradorService.insertarFechaLimiteIVA(this.item_aux_dia_limite);
        } else {
          r = await this.$store.state.services.administradorService.insertarFechaLimiteISR(this.item_aux_dia_limite);
        }
        console.log(r);
        this.$toast.success("Fecha limite de retenciones IVA actualizada con éxito");
        // this.dialog_limite_retenciones = false;
        this.loading_insertar_dia_limite = false;
        // limpiar item aux
        this.item_aux_dia_limite = Object.assign({}, this.item_aux_dia_limite);
        this.item_aux_dia_limite.dia = null;
        this.item_aux_dia_limite.mes = null;
        this.item_aux_dia_limite.anio = null;
        this.item_aux_dia_limite.fecha = null;
        this.isCreate = true;
        this.getFechaLimite();
      } catch (error) {
        console.log(error);
        this.loading_insertar_dia_limite = false;
        this.isCreate = true;
        this.item_aux_dia_limite.dia = null;
        this.item_aux_dia_limite.mes = null;
        this.item_aux_dia_limite.anio = null;
        this.item_aux_dia_limite.fecha = null;
        this.$toast.error("No es posible actualizar la fecha limite de retenciones IVA")
      }
    },
    modificarItemDiaLimite(item) {
      console.log("modificarItemDiaLimite", item);
      // separar la fecha en dia, mes y anio
      console.log(item);
      let fecha = item.fecha.split("-");
      this.item_aux_dia_limite.dia = parseInt(fecha[2]);
      this.item_aux_dia_limite.mes = parseInt(fecha[1]);
      this.item_aux_dia_limite.anio = parseInt(fecha[0]);
      this.item_aux_dia_limite.id = item.id;
      console.log(this.item_aux_dia_limite);
      this.isCreate = false;
    },
    async actualizarFechaLimites() {
      console.log("actualizarFechaLimites");
      try {
        let r = null;
        this.loading_insertar_dia_limite = true;
        let dia = parseInt(this.item_aux_dia_limite.dia);
        let mes = parseInt(this.item_aux_dia_limite.mes);
        let anio = parseInt(this.item_aux_dia_limite.anio);
        let fecha = `${anio}-${mes}-${dia}`;
        this.item_aux_dia_limite.fecha = fecha;
        if (this.isLimiteIva) {
          r = await this.$store.state.services.administradorService.actualizarFechaLimiteIVA(this.item_aux_dia_limite);
        } else {
          r = await this.$store.state.services.administradorService.actualizarFechaLimiteISR(this.item_aux_dia_limite);
        }
        console.log(r);
        this.$toast.success("Fecha limite de retenciones IVA actualizada con éxito");
        this.loading_insertar_dia_limite = false;
        // limpiar item aux
        this.item_aux_dia_limite = Object.assign({}, this.item_aux_dia_limite);
        this.item_aux_dia_limite.dia = null;
        this.item_aux_dia_limite.mes = null;
        this.item_aux_dia_limite.anio = null;
        this.item_aux_dia_limite.fecha = null;
        this.getFechaLimite();
      } catch (error) {
        console.log(error);
        this.loading_insertar_dia_limite = false;
        this.$toast.error("No es posible actualizar la fecha limite de retenciones IVA")
      }
    },
    exportarExcelISR(headers, items) {
      console.log("exportarExcelISR", headers, items);
      let info = [];

      items.forEach(element => {
        console.log(element);
        let estado = (element.activo === 0) ? 'Vencido' : 'Activo';

        let fecha_carga = new Date(element.fecha_carga); // Convertir a objeto Date
        fecha_carga.setDate(fecha_carga.getDate() + 1); // Sumar 1 día
        let fecha_carga_formateada = fecha_carga.toLocaleDateString();

        let fecha_vencimiento = new Date(element.fecha_vencimiento); // Convertir a objeto Date
        fecha_vencimiento.setDate(fecha_vencimiento.getDate() + 1); // Sumar 1 día
        let fecha_vencimiento_formateada = fecha_vencimiento.toLocaleDateString();

        info.push({ 'Estado': estado, 'Fecha de Carga': fecha_carga_formateada, 'Fecha de Vencimiento': fecha_vencimiento_formateada });
      });

      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'Carga_de_retenedores_ISR';
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    exportarExcelIVA(items) {
      console.log("exportarExcelIVA", items);
      let info = [];

      items.forEach(element => {
        console.log(element);
        let estado = (element.activo === 0) ? 'Vencido' : 'Activo';

        let fecha_carga = new Date(element.fecha_carga); // Convertir a objeto Date
        fecha_carga.setDate(fecha_carga.getDate() + 1); // Sumar 1 día
        let fecha_carga_formateada = fecha_carga.toLocaleDateString();

        let fecha_vencimiento = new Date(element.fecha_vencimiento); // Convertir a objeto Date
        fecha_vencimiento.setDate(fecha_vencimiento.getDate() + 1); // Sumar 1 día
        let fecha_vencimiento_formateada = fecha_vencimiento.toLocaleDateString();

        info.push({ 'Estado': estado, 'Fecha de Carga': fecha_carga_formateada, 'Fecha de Vencimiento': fecha_vencimiento_formateada });
      });

      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'Carga_de_retenedores_IVA';
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    async getCupones() {
      console.log("getCupones");
      try {
        this.loading_cupones = true;
        let r = await this.$store.state.services.usuarioService.getCupones();
        console.log(r);
        this.filasCupones = r.data.data;
        this.loading_cupones = false;
      } catch (error) {
        this.loading_cupones = false;
        console.log(error);
        this.$toast.error("No es posible obtener los cupones")
      }
    },

    modificarCupon(item) {
      console.log("modificarCupo", item);
      // realizar una copia del item
      item.rol_id = item.rol_id.id;
      this.item_aux_cupon = Object.assign({}, item);
      console.log(this.item_aux_cupon);
      this.dialog_cupones = true;
      this.isCreate = false;
    },

    crearCupon() {
      console.log("crearCupon");
      this.item_aux_cupon = Object.assign({}, this.default_cupon);
      this.dialog_cupones = true;
      this.isCreate = true;
    },

    cerrar_modal_cupones() {
      console.log("cerrar_modal_cupones");
      this.item_aux_cupon = Object.assign({}, this.default_cupon);
      this.dialog_cupones = false;
      this.getCupones();
    },

    async confirmarCrearCupon() {
      console.log("confirmarCrearCupon");
      try {
        this.loading_cupones = true;
        let r = await this.$store.state.services.usuarioService.postInsertarCupon(this.item_aux_cupon);
        console.log(r);
        this.$toast.success("Cupon creado exitosamente");
        this.loading_cupones = false;
        this.dialog_cupones = false;
        await this.getCupones();
      } catch (error) {
        console.log(error);
        this.loading_cupones = false;
        this.$toast.error("No es posible crear el cupon")
      }
    },

    async confirmarModificarCupon() {
      console.log("confirmarModificarCupon");
      try {
        this.loading_cupones = true;
        let r = await this.$store.state.services.usuarioService.putActualizarCupon(this.item_aux_cupon);
        console.log(r);
        this.$toast.success("Cupon modificado exitosamente");
        this.loading_cupones = false;
        this.dialog_cupones = false;
        await this.getCupones();
      } catch (error) {
        console.log(error);
        this.loading_cupones = false;
        this.$toast.error("No es posible modificar el cupon")
      }
    },


    customFilter(item, queryText) {
      const nit = item.nit ? item.nit.toString().toLowerCase() : '';
      const cui = item.cui ? item.cui.toString().toLowerCase() : '';
      const primerNombre = item.primer_nombre ? item.primer_nombre.toLowerCase() : '';
      const segundoNombre = item.segundo_nombre ? item.segundo_nombre.toLowerCase() : '';
      const primerApellido = item.primer_apellido ? item.primer_apellido.toLowerCase() : '';
      const segundoApellido = item.segundo_apellido ? item.segundo_apellido.toLowerCase() : '';
      const nombreCompleto = `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim();
      const query = queryText.toLowerCase();

      return (
        nit.includes(query) ||
        cui.includes(query) ||
        nombreCompleto.includes(query)
      );
    },

    async solicitarApiTicLabsCa() {
      try {
        this.loading_servicios = true;
        let r = await this.$store.state.services.administradorService.apiTicLabsCa();
        console.log(r);
        if (r.status === 200) {
          this.$toast.success("Inicio de Sesión Exitoso");
          sessionStorage.setItem("api_ticlabs_login", true);
          this.isLoginTicLabsCa = true;
          this.getUsuarios();
        } else {
          this.$toast.error("No es posible iniciar sesión en este momento");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading_servicios = false;
      }
    },

    async solicitarFacturasElectronicas() {
      try {
        this.loading_servicios = true;
        let r = await this.$store.state.services.administradorService.solicitarFacturasElectronicas({
          fecha_inicio: this.anio_seleccionado + '-' + this.mes_inicio + '-01',
          fecha_fin: this.anio_fin_seleccionado + '-' + this.mes_fin + '-01',
          usuario_id: this.usuario_seleccionado.id
        });
        console.log(r);
        if (r.status === 200) {
          this.$toast.success("Facturas electrónicas solicitadas exitosamente");
          sessionStorage.setItem("api_ticlabs_sol", true);
          this.isRequestFacturas = true;
        } else {
          this.$toast.error("No es posible solicitar las facturas electrónicas en este momento");
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible solicitar las facturas electrónicas en este momento");
        this.limpiarSessionStorage();
      } finally {
        this.loading_servicios = false;
      }
    },

    async cargarFacturasElectronicas() {
      try {
        this.loading_servicios = true;
        
        let r = await this.$store.state.services.administradorService.cargarFacturasElectronicas();
        console.log(r);
        if (r.status === 200) {
          this.isMoveFacturas = true;
          this.$toast.success("Facturas electrónicas cargadas exitosamente");
          setTimeout(() => {
            this.$toast.info("Recuerde iniciar sesión en TicLabs para evitar problemas de seguridad");
            this.limpiarSessionStorage();
            this.isLoginTicLabsCa = false;
            this.isRequestFacturas = false;
            this.isMoveFacturas = false;
          }, 8000);
        } else {
          this.$toast.error("No es posible cargar las facturas electrónicas en este momento");
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible cargar las facturas electrónicas en este momento");
      } finally {
        this.loading_servicios = false;
      }
    },

    limpiarSessionStorage() {
      console.log("limpiarSessionStorage");
      sessionStorage.removeItem("api_ticlabs_login");
      sessionStorage.removeItem("api_ticlabs_sol");
      sessionStorage.removeItem("api_ticlabs_move");
    },

    descargarFormatoArchivo() {
      const link = document.createElement('a');
      link.href = 'docs/formato-carga-agentes-retenedores.xlsx'; // Ruta relativa desde la raíz del servidor
      link.download = 'formato_carga_agentes_retenedores.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
}